module.exports = __webpack_public_path__ + "img/model_2.d3a5d9d7.png";